var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 64,
    rx: 10,
    fill: "#F2A047",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 25.6c0-5.296-4.304-9.6-9.6-9.6-5.296 0-9.6 4.304-9.6 9.6 0 7.2 9.6 17.6 9.6 17.6s9.6-10.4 9.6-17.6zm-12.8 0c0-1.76 1.44-3.2 3.2-3.2 1.76 0 3.2 1.44 3.2 3.2a3.2 3.2 0 01-3.2 3.2 3.21 3.21 0 01-3.2-3.2zm-8 19.2V48h22.4v-3.2H23z",
    fill: "#F2A047"
  })));
}
export default SvgLocationIconSvg;